/**
 * Created by Rodrigo Quesada on 16/01/17.
 */
import {Injectable} from '@angular/core';
import {RepeatableScreensManagerDeps} from '../../../shared/step/repeatable-screen-manager.class';
import {FellowshipOrPreceptorshipService} from '../../../../domain/model/education/fellowship-or-preceptorship/fellowship-or-preceptorship.service';
import {RepeatableUserModelScreensManager} from '../../../../components/sections/repeatable/repeatable-user-model-screens-manager.service';

@Injectable()
export class FellowshipOrPreceptorshipScreensManager extends RepeatableUserModelScreensManager {

    constructor(rsmm: RepeatableScreensManagerDeps, protected readonly _modelService: FellowshipOrPreceptorshipService) {
        super(rsmm);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/education/steps/fellowshipOrPreceptorship/fellowship-or-preceptorship-screens-manager.service.ts